<template>
  <div class="compound banner public-content">
    <div class="breadcrumb">推荐产品 <el-button style="margin-left: 10px;" round @click="detail()" v-preventReClick>新建</el-button>
    </div>
    <div class="right-main">
      <div class="data-list">
        <div class="main-content">
          <div class="banner-table">
            <el-table border class="table-cell" :data="tableList">
              <el-table-column label="" width="100">
                <template slot-scope="">
                  <!--  :style="clickId === scope.row.id ? 'color:#409EFF' : 'color:#bfbfbf'" -->
                  <i class="el-icon-s-unfold"></i>
                </template>
              </el-table-column>
              <el-table-column prop="previewUrl" label="预览图">
                <template slot-scope="scope">
                  <div style="display: flex;">
                    <el-image v-for="(item, index) in scope.row.previewUrl" :key="index" style="height: 100px;margin-left: 5px;border: 1px solid #000;" :src="item"
                      :preview-src-list="scope.row.previewUrl">
                    </el-image>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="关联名称id" prop="name"></el-table-column>
              <el-table-column label="操作">
                <template v-slot="scope">
                  <span class="color-blue" @click="detail(scope.row.id)">编辑<br></span>
                  <span class="color-blue" @click="deleteBanner(scope.row.id)">删除</span>
                </template>
              </el-table-column>
            </el-table>
            <div style="color:red">注：拖<i class="el-icon-s-unfold" style="color:#bfbfbf"></i>可调整滑块顺序</div>
            <div class="form-btn" style="margin: 20px 0" v-if="isDrop">
              <el-button round @click="cancel()" v-preventReClick>取消</el-button>
              <el-button round type="primary" @click="submit()" v-preventReClick>保存</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="编辑" :visible.sync="dialogVisible" width="30%" v-if="dialogVisible">
      <div style="display:flex;align-items: center;">
        <span>模块名称：</span>
        <div style="width: 180px;">
          <el-input v-model="modelName" placeholder="请输入内容"></el-input>
        </div>
      </div>
      <div style="font-size: 12px;color:red;margin-left: 80px;" v-if="haveName">名称已被占用，另起一个吧</div>
      <span slot="footer" class="dialog-footer">
        <el-button round type="primary" @click="dialogVisible = false, haveName = false, save()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getBannerPage, delBanner } from '@/api/banner'
import { appRecmendList, deleteRecmendById, updateRecmendInfo } from '@/api/pms'
import Sortable from 'sortablejs'
export default {
  name: 'banner',
  data () {
    return {
      haveName: false,
      modelName: '',
      dialogVisible: false,
      isDrop: false,
      clickId: 0,
      tableList: [],
      tableData: []
    }
  },
  mounted () {
    // 阻止默认行为
    document.body.ondrop = function (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    // 调用 table拖拽排序
    this.rowDrop()
  },
  async created () {
    await this.getAppRecmendList()
    if (this.$checkAwsSdk('normal')) {
      this.$store.dispatch('awsSdk/getAwsSdk', 'normal')
    }
  },
  methods: {

    // 行拖拽
    rowDrop () {
      let tbody = document.querySelector('.el-table__body-wrapper tbody')
      let _this = this
      Sortable.create(tbody, {
        // or { name: "...", pull: [true, false, 'clone', array], put: [true, false, array] }
        group: {
          name: 'words',
          pull: true,
          put: true
        },
        animation: 150, // ms, number 单位：ms，定义排序动画的时间
        onAdd: function (evt) { // 拖拽时候添加有新的节点的时候发生该事件
          console.log('onAdd.foo:', [evt.item, evt.from])
        },
        onUpdate: function (evt) { // 拖拽更新节点位置发生该事件
          console.log('onUpdate.foo:', [evt.item, evt.from])
        },
        onRemove: function (evt) { // 删除拖拽节点的时候促发该事件
          console.log('onRemove.foo:', [evt.item, evt.from])
        },
        onStart: function (evt) { // 开始拖拽出发该函数
          // this.clickId = evt
          console.log('onStart.foo', evt.oldIndex)
          let aaaa = _this.tableList[evt.oldIndex]
          console.log('aaaa', aaaa)
          _this.clickId = aaaa.id
        },
        onSort: function (evt) { // 发生排序发生该事件
          console.log('onUpdate.foo:', [evt.item, evt.from])
        },
        // 一般的业务就用onEnd结束拖拽就够了
        onEnd ({ newIndex, oldIndex }) { // 结束拖拽
          if (newIndex == oldIndex) return
          let currRow = _this.tableList.splice(oldIndex, 1)[0]
          // console.log('currRow', newIndex, currRow)
          _this.tableList.splice(newIndex, 0, currRow)
          let newArray = _this.tableList.splice(0)
          _this.$nextTick(() => {
            _this.isDrop = true
            _this.tableList = newArray
            console.log('onEnd', _this.tableList)
          })
        }
      })
    },
    async getAppRecmendList () {
      await appRecmendList().then(res => {
        if (res.data.success) {
          let dataList = res.data.data.map(item => {
            return {
              ...item,
              previewUrl: item.previewUrl?.split(',')
            }
          })
          this.tableList = dataList
          this.tableData = Object.assign([], dataList)
          // this.queryInfo.total = res.data.data.total
        }
      })
    },
    detail (bannerId) {
      this.$router.push({
        path: '/app/recommendDetail',
        query: {
          id: bannerId,
          type: bannerId ? 'edit' : 'add'
        }
      })
    },
    deleteBanner (bannerId) {
      this.$confirm('是否确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteRecmendById(bannerId).then(res => {
          if (res.data.success) {
            this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success'
            })
            this.getAppRecmendList()
          }
        })
      })
    },

    cancel () {
      this.clickId = 0
      this.isDrop = false
      this.tableList = Object.assign([], this.tableData)
    },
    submit () {
      let param = this.tableList.map((a, i) => {
        delete a.updateTime
        delete a.createTime
        return {
          ...a,
          previewUrl: a.previewUrl.toString(),
          sort: i + 1
        }
      })
      updateRecmendInfo(param).then(res => {
        console.log('res', res)
        if (res.data.success) {
          this.$message.success('保存成功')
          this.clickId = 0
          this.isDrop = false
          this.getAppRecmendList()
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .data-list .el-table tr td img {
  width: auto !important;
}

.el-icon-s-unfold {
  color: #bfbfbf;
}

.el-icon-s-unfold:hover {
  color: #409EFF;
}

.compound {
  .add-category {
    justify-content: flex-start;
  }

  .keywords {
    display: flex;
    justify-content: space-around;
    // width: 750px;
    align-items: center;

    .el-input {
      width: 180px;
    }
  }
}
</style>
